export default __webpack_public_path__ + "static/media/78t.251eed14.jpg";